import axios from "axios";
import VueI18n from "vue-i18n";
import { Store } from "vuex";
import { BUILD_TIMESTAMP } from "@/constants";
import Currencies from "../constants/currencies.constants";

export default class TranslationService {
  private store: Store<{}>;
  private i18n: VueI18n;

  public languages = ["fr", "fr-CA", "en", "en-CA"];

  constructor(store: Store<{}>, i18n: VueI18n) {
    this.store = store;
    this.i18n = i18n;
  }

  public initTranslateLanguage(){
    if(this.store.getters.navClient && this.languages.includes(this.store.getters.navClient.lang)){
        this.refreshTranslation(this.store.getters.navClient.lang)
      } 
      else this.refreshTranslation('fr')
  }

  public refreshTranslation(newLanguage: string) {
    let currentLanguage = this.store.getters.currentLanguage;
    currentLanguage = newLanguage ? newLanguage : "fr";
    if (this.i18n && !this.i18n.messages[currentLanguage]) {
            this.i18n.setLocaleMessage(currentLanguage, {});
      axios.get(`i18n/${currentLanguage}.json?buildTimestamp=${BUILD_TIMESTAMP}`).then((res) => {
        if (res.data) {
                    this.i18n.setLocaleMessage(currentLanguage, res.data);
          this.i18n.locale = currentLanguage;
          this.store.commit("currentLanguage", currentLanguage);
        }
      });
    } else if (this.i18n) {
            this.i18n.locale = currentLanguage;
      this.store.commit("currentLanguage", currentLanguage);
    }
  }

  public refreshCurrency(currency) {
    let currentCurrency = sessionStorage.getItem("currency");
    currentCurrency = currency ? currency : Currencies.EUR.value;
    sessionStorage.setItem("currency", currentCurrency);
    this.store.commit("setCurrency", currentCurrency);
    let gd = this.store.getters.gameData;
    if (gd !== null) gd.clientCurrency = currentCurrency;
    this.store.commit("updateGameData", gd);
    let client = this.store.getters.client;
    client.currency = currentCurrency;
    this.store.commit("setClient", client);
  }
}
